import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import ranger from "../../../../assets/info/ranger-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import styled from "styled-components";
import eziFit from "../../../../assets/info/ford-ranger/ranger-fig-1.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";

const FordRanger = () => {
  useSmallNav("Ford Ranger");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Ford Ranger"} bolder />
        <InfoHero image={ranger} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Czy jesteś posiadaczem Forda Ranger? Szukasz części zawieszenia lub jego ulepszeń?"
              }
            />
            <InfoHeader size="smaller" text={"Trafiłeś we właściwe miejsce."} />
            <p>
              W firmie Pedders Suspension oferujemy szeroką gamę części
              zawieszenia, w tym liczne części wzmocnione, odpowiednie do
              wszelkich zastosowań.
            </p>
            <p>
              Dla osób przewożących ciężkie ładunki lub regularnie holujących
              jesteśmy w stanie zaoferować ulepszone tylne sprężyny i
              amortyzatory, aby lepiej sprostać wymaganiom takiego użytkowania.
            </p>
            <p>
              Dla osób poruszających się na granicy możliwości pojazdu, można je
              uzupełnić o system poduszek powietrznych. Niezależnie od
              zastosowania, będziemy mieli kombinację części do wykonania tego
              zadania.
            </p>
            <p>
              Popularne wśród naszych ulepszeń są zestawy do podnoszenia, czy to
              do poważnej jazdy w terenie, czy po prostu do bardziej agresywnego
              wyglądu. Mamy części, których potrzebujesz.
            </p>
            <p>
              Nowością w naszej ofercie Ranger są w pełni zmontowane przednie
              kolumny Ezifit. Chociaż możemy dostarczyć amortyzatory i sprężyny,
              dla wielu w pełni zmontowany amortyzator ma kilka zalet. Obejmują
              one brak wymogu stosowania ściągacza do sprężyn, WSZYSTKIE nowe
              komponenty, więc brak ponownego użycia starych i zużytych górnych
              mocowań itp., a także oczywiście szybkość montażu. Wystarczy
              odkręcić górne i dolne mocowania, usunąć stare i zamontować nowe.
              Zrobione!
            </p>
            <p>
              Sprawdziłeś naszą listę zestawów i części, ale nadal nie jesteś
              pewien, czego potrzebujesz? Skontaktuj się z nami, gdzie ktoś z
              naszego zespołu będzie mógł Ci pomóc.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/0B2KO6qK2fc"
              title={"Ford Mustang Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              title={"Ford Mustang Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Ford Mustang Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/xZmjhXhHTAg"
              title={"Ford Mustang Video 4"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/5olMu1M-eJ8"
              title={"Ford Mustang Video 5"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Ford")
              .models.find((e) => e.display === "Ranger")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <Gray>
              <InfoHeader
                smaller
                text={"Podniesiony amortyzator piankowy Pedders EziFit"}
              />
              <div>
                <StyledImgParts
                  src={eziFit}
                  alt="Podniesiony amortyzator piankowy Pedders EziFit"
                />
              </div>
            </Gray>
          </div>
        </InfoGrid>
        <InfoFooter make="Ford" model="Ranger" />
      </Container>
    </section>
  );
};

export default FordRanger;

const StyledImgParts = styled.img`
  width: 100%;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
